import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";
import { isBillingEnabled } from "../config/billing";

const BillingContext = createContext(null);

// The pay-from-the-menu checkout and Circle rewards flow are gated on TWO
// independent signals, so a single compromised layer can never switch them on:
//   - allowBilling=true  — frontend opt-in, from the ?allowBilling=true URL param
//   - billingEnable=true — backend opt-in, from the Rista menu Lambda for this cafe
// Both must agree before any of that UI renders or makes a backend call.
export function BillingProvider({ children }) {
  // Frontend gate: fixed for the life of the page load.
  const allowBilling = isBillingEnabled();

  // Backend gate: unknown until the menu response for the active cafe lands,
  // so it starts false and MenuList flips it once the Lambda says billingEnable.
  const [backendBillingEnable, setBackendBillingEnable] = useState(false);

  const setBillingEnable = useCallback((value) => {
    setBackendBillingEnable(Boolean(value));
  }, []);

  const billingAllowed = allowBilling && backendBillingEnable;

  const value = useMemo(
    () => ({ allowBilling, backendBillingEnable, billingAllowed, setBillingEnable }),
    [allowBilling, backendBillingEnable, billingAllowed, setBillingEnable]
  );

  return <BillingContext.Provider value={value}>{children}</BillingContext.Provider>;
}

export function useBilling() {
  const ctx = useContext(BillingContext);
  if (!ctx) throw new Error("useBilling must be used within a BillingProvider");
  return ctx;
}
